import {
	FETCH_DEPANNAGES_TO_DISPATCH_BEGIN,
	FETCH_DEPANNAGES_TO_DISPATCH_SUCCESS,
	FETCH_DEPANNAGES_TO_DISPATCH_ERROR,
	FETCH_DEPANNAGES_TO_DISPATCH_RESET,
	PUT_DEPANNAGE_DISPATCH_BEGIN,
	PUT_DEPANNAGE_DISPATCH_SUCCESS,
	PUT_DEPANNAGE_DISPATCH_RESET,
	PUT_DEPANNAGE_DISPATCH_ERROR,
	FETCH_DM_PLANNING_EN_SUSPENS_BEGIN,
	FETCH_DM_PLANNING_EN_SUSPENS_SUCCESS,
	FETCH_DM_PLANNING_EN_SUSPENS_ERROR,
	FETCH_DM_PLANNING_EN_SUSPENS_RESET,
	FETCH_DM_PLANNING_RDV_BEGIN,
	FETCH_DM_PLANNING_RDV_SUCCESS,
	FETCH_DM_PLANNING_RDV_ERROR,
	FETCH_DM_PLANNING_RDV_RESET,
	FETCH_DISPATCH_EN_COURS_BEGIN,
	FETCH_DISPATCH_EN_COURS_SUCCESS,
	FETCH_DISPATCH_EN_COURS_ERROR,
	FETCH_DISPATCH_EN_COURS_RESET,
	FETCH_DISPATCH_EN_ATTENTE_BEGIN,
	FETCH_DISPATCH_EN_ATTENTE_SUCCESS,
	FETCH_DISPATCH_EN_ATTENTE_ERROR,
	FETCH_DISPATCH_EN_ATTENTE_RESET,
	FETCH_DISPATCH_ANNULEES_BEGIN,
	FETCH_DISPATCH_ANNULEES_SUCCESS,
	FETCH_DISPATCH_ANNULEES_ERROR,
	POST_DEP_MISSION_BEGIN,
	POST_DEP_MISSION_SUCCESS,
	POST_DEP_MISSION_ERROR,
	POST_DEP_MISSION_RESET,
} from "../actions/depannageDispatchActions"

const initialState = {
	depsToDispatch: [],
	fetchDepsToDispatch: {
		loading: false,
		error: false,
	},
	depsEnSuspens: [],
	fetchDepsEnSuspens: {
		loading: false,
		error: false,
	},
	depsRendezVous: [],
	fetchDepsRendezVous: {
		loading: false,
		error: false,
	},
	depsEnCours: [],
	fetchDepsEnCours: {
		loading: false,
		error: false,
	},
	depsEnAttente: [],
	fetchDepsEnAttente: {
		loading: false,
		error: false,
	},
	depsAnnulees: [],
	fetchDepsAnnulees: {
		loading: false,
		error: false,
	},
	putDepsToDispatch: {
		saving: false,
		saved: false,
		error: false,
	},
	// Création/édition de mission (POST upsert) — modal DepMissionV2.
	postDepMission: {
		saving: false,
		saved: false,
		error: false,
	},
}

export default function depannageDispatchReducer(state = initialState, action) {
	let dep_index, dep
	switch (action.type) {
		case FETCH_DEPANNAGES_TO_DISPATCH_BEGIN:
			return {
				...state,
				fetchDepsToDispatch: {
					loading: true,
					error: false,
				},
			}
		case FETCH_DEPANNAGES_TO_DISPATCH_SUCCESS:
			return {
				...state,
				depsToDispatch: action.payload,
				fetchDepsToDispatch: {
					loading: false,
					error: false,
				},
			}
		case FETCH_DEPANNAGES_TO_DISPATCH_ERROR:
			return {
				...state,
				depsToDispatch: [],
				fetchDepsToDispatch: {
					loading: false,
					error: action.payload,
				},
			}
		case FETCH_DEPANNAGES_TO_DISPATCH_RESET:
			return {
				...state,
				depsToDispatch: [],
				fetchDepsToDispatch: {
					loading: false,
					error: false,
				},
			}
		case FETCH_DISPATCH_ANNULEES_BEGIN:
			return {
				...state,
				fetchDepsAnnulees: {
					loading: true,
					error: false,
				},
			}
		case FETCH_DISPATCH_ANNULEES_SUCCESS:
			return {
				...state,
				depsAnnulees: action.payload,
				fetchDepsAnnulees: {
					loading: false,
					error: false,
				},
			}
		case FETCH_DISPATCH_ANNULEES_ERROR:
			return {
				...state,
				depsAnnulees: [],
				fetchDepsAnnulees: {
					loading: false,
					error: action.payload,
				},
			}
		case FETCH_DISPATCH_EN_COURS_BEGIN:
			return {
				...state,
				fetchDepsEnCours: {
					loading: true,
					error: false,
				},
			}
		case FETCH_DISPATCH_EN_COURS_SUCCESS:
			return {
				...state,
				depsEnCours: action.payload,
				fetchDepsEnCours: {
					loading: false,
					error: false,
				},
			}
		case FETCH_DISPATCH_EN_COURS_ERROR:
			// Revue phase B (🟠4) : un sondage raté garde la dernière liste.
			return {
				...state,
				fetchDepsEnCours: {
					loading: false,
					error: action.payload,
				},
			}
		case FETCH_DISPATCH_EN_COURS_RESET:
			return {
				...state,
				depsEnCours: [],
				fetchDepsEnCours: {
					loading: false,
					error: false,
				},
			}
		case FETCH_DISPATCH_EN_ATTENTE_BEGIN:
			return {
				...state,
				fetchDepsEnAttente: {
					loading: true,
					error: false,
				},
			}
		case FETCH_DISPATCH_EN_ATTENTE_SUCCESS:
			return {
				...state,
				depsEnAttente: action.payload,
				fetchDepsEnAttente: {
					loading: false,
					error: false,
				},
			}
		case FETCH_DISPATCH_EN_ATTENTE_ERROR:
			return {
				...state,
				depsEnAttente: [],
				fetchDepsEnAttente: {
					loading: false,
					error: action.payload,
				},
			}
		case FETCH_DISPATCH_EN_ATTENTE_RESET:
			return {
				...state,
				depsEnAttente: [],
				fetchDepsEnAttente: {
					loading: false,
					error: false,
				},
			}
		case FETCH_DM_PLANNING_EN_SUSPENS_BEGIN:
			return {
				...state,
				fetchDepsEnSuspens: {
					loading: true,
					error: false,
				},
			}
		case FETCH_DM_PLANNING_EN_SUSPENS_SUCCESS:
			return {
				...state,
				depsEnSuspens: action.payload,
				fetchDepsEnSuspens: {
					loading: false,
					error: false,
				},
			}
		case FETCH_DM_PLANNING_EN_SUSPENS_ERROR:
			return {
				...state,
				depsEnSuspens: [],
				fetchDepsEnSuspens: {
					loading: false,
					error: action.payload,
				},
			}
		case FETCH_DM_PLANNING_EN_SUSPENS_RESET:
			return {
				...state,
				depsEnSuspens: [],
				fetchDepsEnSuspens: {
					loading: false,
					error: false,
				},
			}
		case FETCH_DM_PLANNING_RDV_BEGIN:
			return {
				...state,
				fetchDepsRendezVous: {
					loading: true,
					error: false,
				},
			}
		case FETCH_DM_PLANNING_RDV_SUCCESS:
			return {
				...state,
				depsRendezVous: action.payload,
				fetchDepsRendezVous: {
					loading: false,
					error: false,
				},
			}
		case FETCH_DM_PLANNING_RDV_ERROR:
			return {
				...state,
				fetchDepsRendezVous: {
					loading: false,
					error: action.payload,
				},
			}
		case FETCH_DM_PLANNING_RDV_RESET:
			return {
				...state,
				depsRendezVous: [],
				fetchDepsRendezVous: {
					loading: false,
					error: false,
				},
			}
		case PUT_DEPANNAGE_DISPATCH_BEGIN:
			return {
				...state,
				putDepsToDispatch: {
					saving: true,
					saved: false,
					error: false,
				},
			}
		case PUT_DEPANNAGE_DISPATCH_SUCCESS:
			dep = action.payload
			dep_index = state.depsToDispatch.findIndex(
				(_dep) => _dep.id === dep.id,
			)
			return {
				...state,
				depsToDispatch: [
					...state.depsToDispatch.slice(0, dep_index),
					dep,
					...state.depsToDispatch.slice(dep_index + 1),
				],
				putDepsToDispatch: {
					saving: false,
					saved: true,
					error: false,
				},
			}
		case PUT_DEPANNAGE_DISPATCH_ERROR:
			return {
				...state,
				putDepsToDispatch: {
					saving: false,
					saved: false,
					error: action.payload,
				},
			}
		case PUT_DEPANNAGE_DISPATCH_RESET:
			return {
				...state,
				putDepsToDispatch: {
					saving: false,
					saved: false,
					error: false,
				},
			}
		case POST_DEP_MISSION_BEGIN:
			return {
				...state,
				postDepMission: { saving: true, saved: false, error: false },
			}
		case POST_DEP_MISSION_SUCCESS:
			return {
				...state,
				postDepMission: { saving: false, saved: true, error: false },
			}
		case POST_DEP_MISSION_ERROR:
			return {
				...state,
				postDepMission: {
					saving: false,
					saved: false,
					error: action.payload,
				},
			}
		case POST_DEP_MISSION_RESET:
			return {
				...state,
				postDepMission: { saving: false, saved: false, error: false },
			}
		case "UPDATE_DEPANNAGE_TO_DISPATCH":
			dep_index = state.depsToDispatch.findIndex(
				(dep) => dep.id === action.id,
			)
			if (dep_index !== -1) {
				dep = Object.assign({}, state.depsToDispatch[dep_index])
				dep[action.field] = action.value
				return {
					...state,
					depsToDispatch: [
						...state.depsToDispatch.slice(0, dep_index),
						dep,
						...state.depsToDispatch.slice(dep_index + 1),
					],
				}
			}
			return state
		default:
			return state
	}
}
